<template>
  <div>
    <px-view-header title="Cadastro de produto" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingProduto">
      <px-circular-loading/>
    </div>
    <v-container>
      <v-row>
        <v-col cols="12">
<!--          initial-image="https://comprador.proxpect.com.br/proxpect-logo.png"-->
          <px-upload-crop-image v-model="produto.foto"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-autocomplete-produto
            required
            only-padrao
            :clearable="false"
            :only-cotavel="false"
            label="Categoria"
            class="required"
            :error="$v.produto.origem.$error"
            @blur="$v.produto.origem.$touch()"
            v-model="produto.origem"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="8">
          <v-text-field
            outlined
            required
            hide-details
            maxlength="100"
            class="required"
            label="Descrição do produto"
            :error="$v.produto.descricao.$error"
            @blur="$v.produto.descricao.$touch()"
            v-model="produto.descricao"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            outlined
            required
            hide-details
            maxlength="50"
            label="Código interno"
            v-model="produto.codigo"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <px-autocomplete-unidade-medida required
                                          class="required"
                                          :error="$v.produto.unidadeMedida.$error"
                                          @blur="$v.produto.unidadeMedida.$touch()"
                                          v-model="produto.unidadeMedida"/>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            outlined
            hide-details
            label="NCM"
            v-mask="['####.##.##']"
            v-model="produto.ncm"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            outlined
            v-model="produto.especificacao"
            label="Especificação"
            counter="1500"
          />
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import { onlyNumbers } from '@/utils/regex-utils';
import ProdutoService from './produtos-service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingProduto: false,
      isCopy: this.$route.params.isCopy,
      produto: {
        origem: null,
        descricao: null,
        codigo: null,
        unidadeMedida: null,
        ncm: null,
        especificacao: null,
        foto: null,
      },
      produtoId: this.$route.params.id,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Produtos' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.produtos' });
    },
    getProduto() {
      this.loadingProduto = true;
      ProdutoService.get(this.produtoId)
        .then((response) => {
          this.produto = response.data;
          if (this.isCopy) {
            this.produto.id = undefined;
            this.produto.codigo = undefined;
            this.produto.foto = null;
          }
        })
        .finally(() => {
          this.loadingProduto = false;
        });
    },
    salvar() {
      this.loading = true;
      this.produto.ncm = onlyNumbers(this.produto.ncm);
      ProdutoService.save(this.produto)
        .then(() => {
          this.$toast('Produto criado com sucesso', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  watch: {
    'produto.origem': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (!oldValue && this.produto.descricao) {
        return;
      }
      if (!newValue) {
        this.produto.descricao = null;
        return;
      }
      this.produto.descricao = newValue.descricao;
    },
  },
  created() {
    if (this.produtoId) {
      this.getProduto();
    }
  },
  validations: {
    produto: {
      origem: {
        required,
      },
      descricao: {
        required,
      },
      unidadeMedida: {
        required,
      },
    },
  },
};
</script>
